<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-practice.svg" can-back-flag="1" isPracticeDetail="true"></Header>
    </header>

    <div id="wrapper">
      <div class="content">
        <section>
          <h3 class="ttl">{{ content.part }}{{ content.chapter }}　問{{ content.question_num }}</h3>
          <div class="inner-box">
            <div class="practice-qbox">
              <h4 class="answer-box">{{ content.answer_title }}</h4>
              <div class="txt-box qno" :class="{'exp': content.answer_title == '解答例'}" v-html="content.answer"></div>
            </div>
            <div class="practice-answer">
              <h4 class="ansttl">解説</h4>
              <div v-html="content.expl"></div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <footer id="footer">
      <div class="footer-box">
        <div class="question-answer-footer">
          <div class="box-l">
            <button type="button" class="btn btn-unit-l" v-on:click.prevent='prevAction'><img src="static/images/common/btn/btn-question-back.svg" alt="問題に戻る"></button>
          </div>
          <div class="box-r">
            <button type="button" class="btn btn-top"
              v-if='content.question_count != content.question_num'
              v-on:click.prevent='linkAction'
              :data-id='content.id'><img src="static/images/common/btn/btn-question-next.svg" alt="次の問題へ"></button>

            <button type="button" class="btn btn-unit-l"
              v-if='content.question_count == content.question_num'
              v-on:click.prevent='linkAction'
              :data-part='content.part'
              :data-chapter='content.chapter'><img src="static/images/common/btn/btn-all-chapter.svg" alt="章全体の解答"></button>
          </div>
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  mounted: function () {
    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-practice")
    $("body").addClass("page-practice-answer")
    cmd.adjustStyle()

    if ( !Object.keys(this.content).length ) {
      this.returnToIndex()
    }
  },
  methods: {
    ...mapActions('PracticeModule', {
      'prevAction': 'prevAction',
      'showDetail': 'showDetail',
      'showAnswerList': 'showAnswerList',
      'returnToIndex': 'returnToIndex',
    }),
    linkAction (e) {
      var element = e.currentTarget
      var id = element.getAttribute('data-id')
      var part = element.getAttribute('data-part')
      var chapter = element.getAttribute('data-chapter')
      if (id) {
        var nextId = parseInt(id) + 1
        var count = this.content.question_count
        this.showDetail([nextId, count])
      } else if (part) {
        this.showAnswerList([part, chapter])
      } else {
        this.showAnswer()
      }
    }

  },
  computed: {
    ...mapGetters('PracticeModule', {
      'content': 'getContent',
    }),
  },
  components: {
    Header
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PracticeAnswer.vue